<template>
  <div>
    <mrc_ess_table v-if="$route.name == 'historyMail'" :headers="headers" :hideAddBtn="true" :paginationOptions="options"
      @turnPage="getlist" :isLoading="loading" :slotKey="[
        'org_level_uuid',
        'user',
        'status',
        'updated_by',
        'created_utc_datetime',
      ]" :items="desserts">
      <template v-slot:search>
        <v-row class="d-flex justify-end" style="
            background: white;
            margin: 0;
            border-top-right-radius: 8px;
            border-top-left-radius: 8px;
            padding: 0 16px;
          ">
          <mrc_ess_advanceFilterAndSearchInput class="mt-4" v-model="systemSeniorQueryString"
            @success="getlist({ cpage: 1 })" :systemFieldMeta="systemFieldMeta"></mrc_ess_advanceFilterAndSearchInput>
        </v-row>
      </template>
      <template v-slot:item.org_level_uuid="{ item }">
        <mrc_ess_chip v-if="item.org_level_uuid != 'null'">
          <span class="text-body-s">
            {{ INT(item.org_level_uuid) }}
          </span>
        </mrc_ess_chip>
        <div class="pl-3 text-caption text--secondary">
          {{ INT(item.client_uuid) }}
        </div>
      </template>

      <template v-slot:item.user="{ item }">
        <div class="text-caption">
          <mrc_ess_chip>
            {{ item.smtp_username }}
          </mrc_ess_chip>
          <!-- style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;max-width:500px;" -->
          <div>
            <span style="color: rgba(0, 0, 0, 0.38)"> to: </span>
            <span style="color: rgba(0, 0, 0, 0.78)">
              {{ item.addressee }}
            </span>
          </div>
        </div>
      </template>
      <!-- 创建人 -->
      <template v-slot:item.updated_by="{ item }">
        {{ item.updated_by }}
      </template>
      <!-- 创建时间 -->
      <template v-slot:item.created_utc_datetime="{ item }">
        {{ item.created_utc_datetime | changeDate("YYYY/MM/DD HH:mm:ss") }}
      </template>
      <!-- 状态 -->
      <template v-slot:item.status="{ item }">
        <mrc_ess_viewbtn :is_used="item.send_stat_save_value" :label="item.send_stat"></mrc_ess_viewbtn>
      </template>

      <!-- <template v-slot:item.mailAttachment="{ item }">
        <div style="position:relative;">
          <v-icon class="material-icons">attachment</v-icon>
          <div style="top: -8px;
    left: 20px;color: #FFFFFF;
    text-align: center;position: absolute;
    border-radius: 50%;width: 14px;
    height: 14px;font-size: 12px;
    line-height: 14px;background: #9E9E9E;">
          </div>
        </div>
      </template> -->

      <!-- 操作 -->
      <template v-slot:item.actions="{ item }">
        <menu-list :list="[
          {
            name: $t('label_View'),
            show: hasBtn('email-history-list'),
            type: 'view',
          },
          {
            name: $t('label_Edit'),
            show:
              hasBtn('email-history-edit') && item.send_stat_save_value == 2,
            type: 'edit',
          },
          {
            name: $t('label_Resend'),
            show: hasBtn('resend-email') && item.send_stat_save_value == 2,
            type: 'resend',
          },
        ]" @handleClick="handleClick($event, item)">
          <template v-slot:showAction>
            <!--  -->
            <v-icon v-btnAuth="['email-history-list', 'resend-email']">mdi-dots-vertical</v-icon>
          </template>
        </menu-list>
      </template>
    </mrc_ess_table>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import { getBusinessList } from "@/service/api/prompt";
import {
  historyMailList,
  historyMailDetails,
  historyEmailUpdate,
  historyMailResend,
} from "@/service/api/historyMail.js";
export default {
  components: {},
  props: {},
  data() {
    return {
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      systemSeniorQueryString: [],
      disabled: true,
      list: {},
      options: {
        pagesize: this.$store.state.pageSize, //条数
        cpage: this.$store.state.cpage, //页数
        totalcount: null, //总条数
        totalpage: null, //总页数
      },
      loading: false,
      desserts: [],
      select_arr: [],
    };
  },
  computed: {
    // menulist () {
    //   return
    // },
    headers() {
      return [
        {
          text: this.$t("label_units_and_customers"),
          align: "start",
          value: "org_level_uuid",
          sortable: false,
        },
        {
          text: this.$t("label_sender_and_recipient"),
          value: "user",
          sortable: false,
          align: "start",
        },
        {
          text: this.$t("label_Email_message"),
          value: "mail_title",
          sortable: false,
          align: "start",
        },
        {
          text: this.$t("label_founder"),
          value: "updated_by",
          sortable: false,
          align: "start",
        },
        {
          text: this.$t("label_creation_time"),
          value: "created_utc_datetime",
          sortable: false,
          align: "start",
        },
        // {
        //   text: this.$t('label_annex'),
        //   value: 'mailAttachment',
        //   sortable: false,
        //   width: 100,
        // },
        {
          text: this.$t("label_The_execution_status"),
          value: "status",
          sortable: false,
        },
        {
          text: "",
          value: "actions",
          sortable: false,
          align: "end",
        },
      ];
    },
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1);
  },
  async created() {
    await this.getBtnPermissionList();
  },
  watch: {
    $route(v) {
      if (v.name == "historyMail") {
        this.getlist();
      }
    },
  },
  async mounted() {
    getBusinessList({
      prompt_name: "org_level_for_clients",
    }).then((res) => {
      if (res.code == 200) {
        this.select_arr = res.data;
      }
    });
    await this.getlist();
  },
  beforeDestroy() { },
  methods: {
    async getlist(obj) {
      this.loading = true;
      if (
        this.desserts &&
        this.desserts.length == 1 &&
        this.options.cpage != 1 &&
        this.$route.params.type == "del"
      )
        this.options.cpage--;
      if (obj) {
        const { cpage, pagesize } = obj;

        this.options = { ...this.options, ...obj };
      }
      const res = await historyMailList({
        cpage: this.options.cpage,
        pagesize: this.options.pagesize,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      });
      if (res.code == 200) {
        this.desserts = res.data;
        this.options.totalcount = res.totalcount;
        this.options.totalpage = res.totalpage;
        this.systemFieldMeta = res.systemFieldMeta;
        this.field_alias_name = res.field_alias_name;
        this.table_alias_name = res.table_alias_name;
      }
      this.loading = false;
    },
    addStaffLeave() {
      this.$store.commit("set_subPage_name", "");
      this.$store.commit("set_uuid", "");
      this.$store.commit("set_iconstatus", ""); //行内进图标显示
      this.$router.push({
        name: "addStaffLeave",
      });
    },
    godetail(item) {
      this.$ls.set("mail_type", item.send_stat_save_value);
      this.$store.commit("set_iconstatus", true); //行内进图标显示
      this.$store.commit("set_subPage_name", item.mail_title);
      this.$store.commit("set_uuid", item.uuid); //
      this.$router.push({
        name: "historyMailDeatil",
      });
    },
    handleClick({ item }, obj) {
      switch (item.type) {
        case "view":
          this.godetail(obj);
          break;
        case "edit":
          this.$ls.set("mail_type", obj.send_stat_save_value);
          this.$store.commit("set_subPage_name", obj.mail_title);
          this.$store.commit("set_iconstatus", false); //行内进图标显示
          this.$store.commit("set_uuid", obj.uuid); //
          this.$router.push({
            name: "historyMailDeatil",
          });
          break;
        case "resend":
          // if (obj.send_stat_save_value == 1) return this.$Message({ text: this.$t('只能重新发送失败的邮件') })
          this.$myConfirm({ content: this.$t("label_confirm_to_resend") })
            .then((res) => {
              historyMailResend({ uuid: obj.uuid }).then((res) => {
                if (res.code == 200) {
                  this.$Message({
                    text: this.$t("message_The_operation_was_successful"),
                  });
                  if (this.desserts.length == 1) this.options.cpage--;
                  this.getlist();
                }
              });
            })
            .catch((err) => { });
          break;
      }
    },
    success() { },
    cancel() { },
  },
};
</script>

<style scoped>
.cardtitle {
  position: relative;
}

.emailbtn {
  position: absolute;
  right: 70px;
  top: -50px;
}

.dowanTemplate {
  position: absolute;
  right: 180px;
  top: -50px;
}
</style>
